import SimpleSearchComponent from './simple';
import * as AdvancedSearch from './advanced';

export {
    SimpleSearchComponent,
    AdvancedSearch
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/index.js